import { UserRole, UserStatus as UserStatusType } from '../types/index.js';

export const UserRoles = UserRole;
export const UserStatus = UserStatusType;

/**
 * @deprecated Use UserRole enum from @addviseo/shared/types instead
 */
export const ROLES = UserRole;

export const ROLES_LABELS: Record<UserRole, string> = {
  [UserRole.ADMINISTRATOR]: 'Administrateur',
  [UserRole.BENEFICIARY]: 'Bénéficiaire',
  [UserRole.ADVISOR]: 'Consultant',
};

export const USER_COLORS: Record<UserRole, string> = {
  [UserRole.ADMINISTRATOR]: 'secondary',
  [UserRole.BENEFICIARY]: 'primary-muted',
  [UserRole.ADVISOR]: 'accent',
};

export const USER_LOADER_COLORS: Record<UserRole, string> = {
  [UserRole.ADMINISTRATOR]: 'marine',
  [UserRole.BENEFICIARY]: 'marine',
  [UserRole.ADVISOR]: 'sarcelle',
};

export const USER_DIALOG_ICON_COLORS: Record<UserRole, string> = {
  [UserRole.ADMINISTRATOR]: 'accent',
  [UserRole.BENEFICIARY]: 'accent',
  [UserRole.ADVISOR]: 'sarcelle',
};

export default {
  ROLES,
  UserRoles,
  UserStatus,
  ROLES_LABELS,
  USER_COLORS,
  USER_LOADER_COLORS,
  USER_DIALOG_ICON_COLORS,
};
